// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextBlock-module--wrapper--Ei5sk","block":"TextBlock-module--block--1lh6s"};